import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../config/global";
import { useEffect, useState } from "react";
import { getConfigSavings } from "../../../core/service/api_saving";

type QuickAmountProps = {
  data: any;
  onChangeValue: (value: number) => void;
};

export const QuickAmountComponent = (props: QuickAmountProps) => {
  const { t } = useTranslation();
  const AMOUNT_ENUM = [1000, 2000, 5000, 10000, 20000, 50000, 75000, 100000];

  const [selectedAmount, setSelectedAmount] = useState<number>(0);

  interface AmountCardProps {
    val: any;
    onClick: () => void;
    isActive: boolean;
  }

  const handleReset = () => {
    setSelectedAmount(0);
  };

  useEffect(() => {
    props.onChangeValue(selectedAmount);
  }, [selectedAmount]);

  const AmountCard = ({ val, onClick, isActive }: AmountCardProps) => {
    return (
      <>
        <div
          className={`p-2 text-sm text-center items-center border-1 rounded-lg ${isActive ? "text-blue-700 border-blue-700" : "text-slate-500"}`}
          onClick={onClick}
        >
          <span className={`text-xs ${isActive ? "font-medium" : ""}`}>
            {val}
          </span>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full border-b-2 border-slate-300 pt-12 pb-2 text center">
          <div className="text-center">
            <span className="font-medium text-dark text-3xl">Rp. </span>
            <span className="text-4xl text-slate-400">{selectedAmount}</span>
          </div>
        </div>
        <div className="grid grid-cols-3  gap-2">
          {AMOUNT_ENUM.map((item, index) => (
            <AmountCard
              key={index}
              val={formatCurrency(item)}
              onClick={() => {
                setSelectedAmount(item);
              }}
              isActive={selectedAmount === item}
            />
          ))}
          <div
            className="p-2 text-sm text-center items-center border-1 border-danger rounded-lg text-danger"
            onClick={() => handleReset()}
          >
            {t("SAVING.reset")}
          </div>
        </div>
      </div>
    </>
  );
};
